import { once } from 'ramda';
import { UserSyncArguments } from 'user-sync/index.types';
import { getUserSyncURL } from './utils';

const ID = '23_26_29_33';
const IABid = [32];

export const createPixel = (): HTMLImageElement => {
  const img = document.createElement('img');
  img.style.display = 'none';
  img.src = `https://ib.adnxs.com/getuid?${getUserSyncURL('23,26,29')}$UID`;

  return img;
};

export default once(({ userSyncPixelsManager, fastdom, context }: UserSyncArguments): void =>
  userSyncPixelsManager.create(context.gdprConsent, ID, IABid, () => {
    const img = createPixel();
    fastdom.mutate(function userSyncAppnexusAddElement() {
      document.body.appendChild(img);
    });
  }),
);
